import { BriefcaseBusiness, Rocket, Users } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

const icons = [BriefcaseBusiness, Rocket, Users];

function CountryCareerSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Career Prospects"
          title={country.career.title}
          description={country.career.summary}
          center={false}
        />

        <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {country.career.points.map((point, index) => {
            const Icon = icons[index % icons.length];

            return (
              <article
                key={point}
                className="signature-card signature-card-interactive rounded-2xl p-5"
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <p className="mt-4 text-sm leading-relaxed text-slate-text/85">{point}</p>
              </article>
            );
          })}
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryCareerSection;
